import { render, staticRenderFns } from "./NolaNovelEmptyList.vue?vue&type=template&id=71100d15&scoped=true"
import script from "./NolaNovelEmptyList.vue?vue&type=script&lang=ts"
export * from "./NolaNovelEmptyList.vue?vue&type=script&lang=ts"
import style0 from "./NolaNovelEmptyList.vue?vue&type=style&index=0&id=71100d15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71100d15",
  null
  
)

export default component.exports